/*
 * @Descripttion:
 * @Author: wyx
 * @Date: 2020-09-11 09:52:06
 * @LastEditors: wyx
 * @LastEditTime: 2020-09-25 10:29:42
 */
import { router } from "@/router/";

class Auth {

    static YT_JY_TOKEN = "yt-dc-token";
    static YT_JY_INFO = "yt_user";

    //取得本地系统缓存信息
    static getToken() {
        let token = localStorage.getItem(Auth.YT_JY_TOKEN);
        return token;
    }

    //取得本地系统缓存信息
    static getInfo() {
        let info = localStorage.getItem(Auth.YT_JY_INFO);
        if (info) {
            return JSON.parse(info);
        } else {
            return null;
        }
    }

    //删除本地系统缓存新
    static removeLocalSysInfo() {
        localStorage.removeItem(Auth.YT_JY_TOKEN);
        localStorage.removeItem(Auth.YT_JY_INFO);
    }

    //登出
    static logout() {
        Auth.removeLocalSysInfo();
        window.location.href = 'http://' + window.location.host + '/main/index'
    }

    //是否登录
    static isLogin() {
        let token = Auth.getToken();
        if (token) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * 退出登录
     */
    static toLoginIn() {
        Auth.logout();
    }
}

export default Auth;
